import {
  gridFilteredSortedRowIdsSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";
import pluralize from "pluralize";

declare module "@mui/x-data-grid-pro" {
  interface FooterPropsOverrides {
    totalRows: number;
    checkboxSelection: boolean;
    selectedRowsAmount: number;
  }
}

interface Props {
  totalRows: number;
  checkboxSelection: boolean;
  selectedRowsAmount: number;
}

export function CustomFooterComponent({
  totalRows,
  checkboxSelection,
  selectedRowsAmount,
}: Props) {
  const apiRef = useGridApiContext();
  const filteredRowIds = useGridSelector(
    apiRef,
    gridFilteredSortedRowIdsSelector,
  );
  const filteredRowCount = filteredRowIds.length;

  return (
    <div className="flex h-[52px] flex-row items-center justify-between">
      <div>
        {checkboxSelection && selectedRowsAmount > 0 ? (
          <span>{`${selectedRowsAmount} ${pluralize("row", selectedRowsAmount)} selected`}</span>
        ) : null}
      </div>
      <div>
        Total rows: {filteredRowCount}/{totalRows}
      </div>
    </div>
  );
}
